import { Quote } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal, RevealStagger, staggerItem } from "@/components/Reveal";
import { testimonials } from "@/data/content";

export default function Testimonials() {
  return (
    <section className="py-14 lg:py-20 bg-white" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-5">
        <Reveal className="max-w-2xl mb-14">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-pristine-aquadeep mb-4">Testimonials</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-medium text-pristine-navy tracking-tight">
            What Our Customers Say
          </h2>
        </Reveal>

        <RevealStagger className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <motion.figure
              key={i}
              variants={staggerItem}
              data-testid={`testimonial-${i}`}
              className="flex flex-col rounded-2xl border border-pristine-aqua bg-pristine-surface p-8 shadow-[0_8px_32px_rgba(15,58,112,0.05)]"
            >
              <Quote className="h-8 w-8 text-pristine-aquadeep" />
              <blockquote className="mt-5 text-base text-pristine-navy/80 leading-relaxed flex-1">
                {t.quote}
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-pristine-aqua">
                <span className="block font-heading text-base font-semibold text-pristine-navy">{t.name}</span>
                <span className="block text-sm text-pristine-aquadeep">{t.location}</span>
              </figcaption>
            </motion.figure>
          ))}
        </RevealStagger>
      </div>
    </section>
  );
}
